'use client';

import { BlogPostEntry, ImageAsset } from '@/utils/types';

import Image from 'next/image';
import Link from 'next/link';
import { motion } from 'framer-motion';

type WorkCardProps = {
  work: BlogPostEntry;
};

export default function WorkCard({ work }: WorkCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Link href={`/blogs/${work.fields.slug}`} className="group">
        <div className="card bg-base-100 w-full h-full shadow-sm">
          <figure>
            <Image
              src={
                (work.fields.coverImage as ImageAsset).fields?.file?.url || ''
              }
              alt={
                typeof work.fields.title === 'string'
                  ? work.fields.title
                  : 'Blog post image'
              }
              width={800}
              height={500}
              className="w-full h-90 object-cover transition-transform duration-300 group-hover:scale-105 rounded-lg"
            />
          </figure>
          <div className="card-body">
            <h2 className="card-title">
              {typeof work.fields.title === 'string'
                ? work.fields.title
                : 'Untitled'}
            </h2>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
